export default __webpack_public_path__ + "static/O0102-0536478e1b3a3652afb85bd37ba7140a.png";